export const USER_ROLES = {
	superAdmin: 1000,
	admin: 100,
	staff: 101,
};

export const WEB_ACCOUNT = 'Web';

export const FEATURE_TYPES = [
	{
		key: 'OBR',
		name: 'Onboard Resident',
		label: 'Onboarding a Resident',
	},
	{
		key: 'ICP',
		name: 'Initial Care Plan',
		label: 'Create a Care Plan',
	},
	{
		key: 'MB',
		name: 'Medical Bot',
		label: 'Get Medical Advice',
	},
	{
		key: 'OCP',
		name: 'Optimize Care Plan',
		label: 'Optimize a Care Plan',
	},
	{
		key: 'DS',
		name: 'Detail Summarizer',
		label: 'Detail Summarizer',
	},
	{
		key: 'PC',
		name: 'Plan Configuration',
		label: 'Plan Configuration',
	},
];

export const FEATURE_TYPES_KEYS = ['ICP', 'OCP', 'MB'];

export const USER_TYPES = [
	{
		key: 'TRU',
		name: 'Trail User',
		label: 'TrailUser',
	},
	{
		key: 'DMU',
		name: 'Demo User',
		label: 'DemoUser',
	},
	{
		key: 'SBU',
		name: 'SandBox User',
		label: 'SandBoxUser',
	},
];

export const TOOLTIPS = {
	initialCarePlan: {
		elderId: 'Select the Elder ID to generate the Initial Care Plan',
		uploadFile:
			'Please attach files that contain medical records and elder profile details to be considered for the Initial Care Plan generation.',
	},
};

export const DATE_FILTER = ['Week', 'Month'];

export const MONTHS = [
	'Jan',
	'Feb',
	'Mar',
	'Apr',
	'May',
	'Jun',
	'Jul',
	'Aug',
	'Sep',
	'Oct',
	'Nov',
	'Dec',
];

export const DAYS = ['Mon', 'Tue', 'Wed', 'Thr', 'Fri', 'Sat', 'Sun'];

export const ERROR_STATE = {
	status: false,
	msg: '',
};

export const ExternalAPIType = {
	reApi: 'resident',
	cpApi: 'carePlan',
	cnApi: 'careNote',
	otApi: 'otherData',
};
